import { Link as MuiLink } from "@material-ui/core";
import styled from "styled-components/macro";

export const Link = styled(MuiLink)`
  cursor: pointer;
`;
